// Permission enums for role-based access control
export enum Permissions {
  // Lien Process Module
  LIEN_PROCESS_VIEW = "view_liensearch", //yes done
  LIEN_CHANGE_LIEN = "change_lien", //yes done
  LIEN_PROCESS_CREATE = "add_liensearch", //yes  done
  LIEN_PROCESS_EDIT = "change_liensearch", //yes done
  LIEN_PROCESS_DELETE = "delete_lien",

  //Drag Permissions
  LIEN_DRAG_APPROVE = "approve_liensummary", //yes
  LIEN_DRAG_WAIVER = "approve_waiver", //yes

  // Lien Summary & History
  LIEN_SUMMARY_VIEW = "view_lien",
  LIEN_SUMMARY_EDIT = "change_liensummary", //"lien_summary_edit", done
  LIEN_SUMMARY_AUDIT_LOGS = "lien_summary_audit_logs",
  LIEN_SUMMARY_GENERATE_WAIVER = "lien_summary_generate_waiver",
  LIEN_SUMMARY_EDIT_WAIVER = "change_waiver", // done
  LIEN_SUMMARY_PREVIEW_PDF = "lien_summary_preview_pdf",

  // Staff Members Module
  STAFF_MEMBERS_VIEW = "view_systemuser", //yes
  STAFF_MEMBERS_CREATE = "add_systemuser", //yes
  STAFF_MEMBERS_EDIT = "change_systemuser", //yes
  STAFF_MEMBERS_DELETE = "delete_systemuser",

  // Roles & Permissions Module
  ROLES_VIEW = "view_group", //yes
  ROLES_CREATE = "add_group", //yes
  ROLES_EDIT = "change_group", //yes
  ROLES_DELETE = "delete_group",
  PERMISSIONS_MANAGE = "permissions_manage",

  // Notifications Settings
  NOTIFICATIONS_VIEW = "notifications_view",
  NOTIFICATIONS_EDIT = "notifications_edit",
  CONFIGURATION_MANAGE = "configuration_manage",

  // Profile Module
  // PROFILE_VIEW = 'profile_view',
  // PROFILE_EDIT = 'profile_edit',

  // System Administration
  SYSTEM_ADMIN = "administrator",
  USER_MANAGEMENT = "user_management",
}
//All New Permissions
// const allPermissions = [
//   "add_group",
//   "change_group",
//   "view_group",
//   "add_lien",
//   "change_lien",
//   "view_lien",
//   "add_liensearch",//new
//   "change_liensearch",//new
//   "view_liensearch",//new
//   "add_liensummary",//new
//   "approve_liensummary",
//   "change_liensummary",//new
//   "view_liensummary",//new
//   "add_waiver",//new
//   "approve_waiver",
//   "change_waiver",//new
//   "view_waiver",//new
//   "add_systemuser",
//   "change_systemuser",
//   "view_systemuser",
// ];

// Permission labels for display purposes
export const PermissionLabels: Record<Permissions, string> = {
  [Permissions.LIEN_PROCESS_VIEW]: "View Lien Process",
  [Permissions.LIEN_PROCESS_CREATE]: "Create Lien Process",
  [Permissions.LIEN_PROCESS_EDIT]: "Edit Lien Process",
  [Permissions.LIEN_CHANGE_LIEN]: "Drag Lien Process",
  [Permissions.LIEN_PROCESS_DELETE]: "Delete Lien Process",
  [Permissions.LIEN_DRAG_APPROVE]: "Move to Approved",
  [Permissions.LIEN_DRAG_WAIVER]: "Move to Waiver",

  [Permissions.LIEN_SUMMARY_VIEW]: "View Lien Summary",
  [Permissions.LIEN_SUMMARY_EDIT]: "Edit Lien Summary",
  [Permissions.LIEN_SUMMARY_AUDIT_LOGS]: "View Audit Logs",
  [Permissions.LIEN_SUMMARY_GENERATE_WAIVER]: "Generate Waiver",
  [Permissions.LIEN_SUMMARY_EDIT_WAIVER]: "Edit Waiver",
  [Permissions.LIEN_SUMMARY_PREVIEW_PDF]: "Preview PDF",

  [Permissions.STAFF_MEMBERS_VIEW]: "View Staff Members",
  [Permissions.STAFF_MEMBERS_CREATE]: "Create Staff Members",
  [Permissions.STAFF_MEMBERS_EDIT]: "Edit Staff Members",
  [Permissions.STAFF_MEMBERS_DELETE]: "Delete Staff Members",

  [Permissions.ROLES_VIEW]: "View Roles",
  [Permissions.ROLES_CREATE]: "Create Roles",
  [Permissions.ROLES_EDIT]: "Edit Roles",
  [Permissions.ROLES_DELETE]: "Delete Roles",
  [Permissions.PERMISSIONS_MANAGE]: "Manage Permissions",

  [Permissions.NOTIFICATIONS_VIEW]: "View Notifications Settings",
  [Permissions.NOTIFICATIONS_EDIT]: "Edit Notifications Settings",
  [Permissions.CONFIGURATION_MANAGE]: "Manage System Configuration",

  // [Permissions.PROFILE_VIEW]: 'View Profile',
  // [Permissions.PROFILE_EDIT]: 'Edit Profile',

  [Permissions.SYSTEM_ADMIN]: "System Administrator",
  [Permissions.USER_MANAGEMENT]: "User Management",
};

// Route to permission mapping
// Empty array means the route is accessible to all authenticated users
// Routes not listed here are accessible to all authenticated users by default
export const RoutePermissions: Record<string, Permissions[]> = {
  // Dashboard - accessible to all authenticated users
  "/": [],
  "/dashboard": [],
  
  // User Management - requires specific permissions
  "/user-management": [
    Permissions.STAFF_MEMBERS_VIEW,
    Permissions.ROLES_VIEW,
  ],
  
  // Lien Process - requires view permission
  "/lien-process": [Permissions.LIEN_PROCESS_VIEW],
  
  // Lien Summary History - requires view permission
  "/lien-summary-history": [Permissions.LIEN_SUMMARY_VIEW],
  
  // Historical Report - accessible to all (controlled by orgConfig in UI)
  "/historically-lien-report": [],
  
  // Profile - accessible to all authenticated users
  "/profile": [Permissions.SYSTEM_ADMIN],
  
  // AI - accessible to all authenticated users (controlled by orgConfig in UI)
  "/ai": [],
  
  // Products - accessible to all authenticated users
  "/products": [Permissions.SYSTEM_ADMIN],
  
  // App Setup routes - checked separately in layout (requires superUser or ADMIN)
  "/app-setup/lienandopportunity": [], // Checked in layout
  "/app-setup/documents": [], // Checked in layout
  "/app-setup/dashboards": [], // Checked in layout
  "/app-setup/searchExemption": [], // Checked in layout
  "/app-setup/all-jobs": [], // Checked in layout
  
  // Legacy routes (if still in use)
  // "/staff-members": [Permissions.STAFF_MEMBERS_VIEW],
  // "/roles-permissions": [Permissions.ROLES_VIEW],
  // "/roles/add": [Permissions.ROLES_CREATE],
  // "/notifications-settings": [Permissions.NOTIFICATIONS_VIEW],
  // "/set-new-configuration": [Permissions.CONFIGURATION_MANAGE],
  // "/preview-pdf": [Permissions.LIEN_SUMMARY_PREVIEW_PDF],
};

// API Permission interface to match the new response structure
export interface ApiPermission {
  id: number;
  name: string;
  code: string;
}

// API Permissions response structure
export interface ApiPermissionsResponse {
  systemuser?: ApiPermission[];
  group?: ApiPermission[];
  [key: string]: ApiPermission[] | undefined;
}

// User permission interface
export interface UserPermissions {
  permissions: Permissions[];
}
